/*  ========================================================================
    # Scripts - Menu toggle
    ========================================================================  */

/**
 * Script that opens and closes the mobile menu.
 */

const MenuToggle = {
  cfg: {
    buttonElement: document.querySelector('.c-header__toggle'),
    submenuToggleElements: document.querySelectorAll('.c-header__mobile-nav-submenu-toggle'),
    headerElement: document.querySelector('.c-header'),
    bodyElement: document.querySelector('body'),
    states: {
      openHeader: 'c-header--open',
      openBody: 'menu-open',
      submenuOpen: 'active'
    }
  },

  /**
   * Handle menu toggle.
   */
  handleToggle() {
    this.cfg.buttonElement.addEventListener('click', () => {
      this.cfg.headerElement.classList.toggle(this.cfg.states.openHeader);
      this.cfg.bodyElement.classList.toggle(this.cfg.states.openBody);
    });
  },

  /**
   * Handle submenu toggle.
   */
  handleSubmenuToggle() {
    this.cfg.submenuToggleElements.forEach((toggleElement) => {
      toggleElement.addEventListener('click', (event) => {
        event.preventDefault();

        toggleElement.classList.toggle(this.cfg.states.submenuOpen);
        const liParent = toggleElement.closest('li');
        const submenuWrapper = liParent.querySelector('.c-header__mobile-nav-submenu-wrapper');
        submenuWrapper.classList.toggle(this.cfg.states.submenuOpen);
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.buttonElement) {
      this.handleToggle();
    }

    if (this.cfg.submenuToggleElements && this.cfg.submenuToggleElements.length > 0) {
      this.handleSubmenuToggle();
    }
  }
};

export default MenuToggle;
